import { render, staticRenderFns } from "./SelectTab.vue?vue&type=template&id=21821be9&scoped=true&"
import script from "./SelectTab.vue?vue&type=script&lang=js&"
export * from "./SelectTab.vue?vue&type=script&lang=js&"
import style0 from "./SelectTab.vue?vue&type=style&index=0&id=21821be9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21821be9",
  null
  
)

export default component.exports